import httpInstance from '../httpInstance';

const putCommercialCategoryService = async (body) => {
  let res;
  const endpoint = '/back-office/v1/commerce-info/tap-to-phone/update';
  await httpInstance.put(
    endpoint,
    body,
  ).then((dataResponse) => {
    res = dataResponse;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default putCommercialCategoryService;
